angular.module('execution-deadline', ['core'])
    .factory('ExecutionDeadline', function ($resource, $filter) {
        return $resource('/crm/api/execution-deadlines/:id', {}, {
            list: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/execution-deadlines/table'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
    })
    .service('ExecutionDeadlineService', function ($rootScope, modals, ExecutionDeadline, $filter) {
        this.add = () => {
            let entity = {
                active: true,
                id: null
            };
            return editModal(entity);
        };
        this.edit = id => ExecutionDeadline.get({id: id}, entity => editModal(entity))
        this.remove = item => modals.confirmDelete(`${item.value} ${$filter("localized")(item.name)}`, () => ExecutionDeadline.delete({id: item.id}, () => $rootScope.$broadcast('executiondeadline.updated')).$promise);

        function editModal(entity) {
            return modals.open('app/execution-deadline/edit-modal.html', 'ExecutionDeadlineDialogController', entity, {size: "md"}, "$ctrl");
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('executionDeadlineList', {
            parent: 'app',
            url: '/execution-deadline?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': "executionDeadlineList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (ExecutionDeadline, $stateParams) => ExecutionDeadline.table(angular.copy($stateParams)).$promise
            }
        });
    });
